import Loader from "./Loder"


export const Buttons = ({ btnText, loading, Iconbefore, onClick, Iconafter, disabled = '', classN, loadindColor = "#FFF", disabledClass = 'text-black flex items-center justify-center rounded-6px shadow-primaryBtnShadow px-4 py-2 text-xl gap-1 font-medium relative cursor-not-allowed border-scogoddd bg-scogoOrange' }) => {
    if (disabled === '') disabled = loading
    return <>
        <>
            <button className={disabled === '' ? disabledClass : classN}
                onClick={onClick}
                disabled={disabled}
            >

                {
                    loading &&

                    <div className=''>
                            <Loader color={loadindColor} size="20" speed="1" thickness="3" />
                    </div>
                }
                <div className={loading ? "hidden" : "flex items-center justify-center"}>
                    {Iconbefore ? Iconbefore : ""}
                    {btnText}
                    {Iconafter ? Iconafter : ""}
                </div>
            </button>
        </>

    </>

}